export default __webpack_public_path__ + "static/media/plan-table.2f1fdc28.png";